export const countryListByRegion = {
  "Asia (Region)": [
    "AF",
    "AM",
    "AZ",
    "BH",
    "BD",
    "BT",
    "BN",
    "KH",
    "CN",
    "CY",
    "GE",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IL",
    "JP",
    "JO",
    "KZ",
    "KW",
    "KG",
    "LA",
    "LB",
    "MY",
    "MV",
    "MN",
    "MM",
    "NP",
    "KP",
    "OM",
    "PK",
    "PS",
    "PH",
    "QA",
    "SA",
    "SG",
    "KR",
    "LK",
    "SY",
    "TW",
    "TJ",
    "TH",
    "TR",
    "TM",
    "AE",
    "UZ",
    "VN",
    "YE",
  ],
  "Europe (Region)": [
    "AL",
    "AD",
    "AT",
    "BY",
    "BE",
    "BA",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FO",
    "FI",
    "FR",
    "DE",
    "GI",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "XK",
    "LV",
    "LI",
    "LT",
    "LU",
    "MK",
    "MT",
    "MD",
    "MC",
    "ME",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "RU",
    "SM",
    "RS",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "UA",
    "GB",
    "VA",
  ],
  "Africa (Region)": [
    "DZ",
    "AO",
    "BJ",
    "BW",
    "BF",
    "BI",
    "CM",
    "CV",
    "CF",
    "TD",
    "KM",
    "CG",
    "CD",
    "DJ",
    "EG",
    "GQ",
    "ER",
    "SZ",
    "ET",
    "GA",
    "GM",
    "GH",
    "GN",
    "GW",
    "CI",
    "KE",
    "LS",
    "LR",
    "LY",
    "MG",
    "MW",
    "ML",
    "MR",
    "MU",
    "MA",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RW",
    "ST",
    "SN",
    "SC",
    "SL",
    "SO",
    "ZA",
    "SS",
    "SD",
    "TZ",
    "TG",
    "TN",
    "UG",
    "EH",
    "ZM",
    "ZW",
    "SSD",
  ],
  "North America (Region)": ["CA", "MX", "US"],
  "South America (Region)": [
    "AR",
    "BO",
    "BR",
    "CL",
    "CO",
    "EC",
    "GY",
    "PE",
    "PY",
    "SR",
    "UY",
    "VE",
  ],
};

export function debounce(func, delay) {
  let timerId;

  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      func(...args);
      timerId = null;
    }, delay);
  };
}

export function convertRuntime(minutes) {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  let result;
  if (hours === 0) {
    result = `${mins}m`;
  } else if (mins === 0) {
    result = `${hours}h`;
  } else {
    result = `${hours}h${mins}m`;
  }

  return result;
}

export function convertToCurrency(num) {
  return "$" + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getCurrentWeekRange() {
  const today = new Date();
  const currentDay = today.getDay(); 
  const startDate = new Date(today);
  const endDate = new Date(today);

  startDate.setDate(today.getDate() - ((currentDay + 6) % 7));
  endDate.setDate(today.getDate() + 7 - ((currentDay + 6) % 7));
  const startFormatted = startDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
  });
  const endFormatted = endDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
  });

  return `${startFormatted} to ${endFormatted}`;
}


//main function
export function extractDetailData(
  type,
  rawData,
  langConfig,
  genreList,
  forTag
) {
  let poster_rootpath = "https://www.themoviedb.org/t/p/original";
  let poster_notfound =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png";

  let original_language = langConfig
    .filter((item) => item.iso_639_1 === rawData.original_language)
    .map((item) => item.english_name);
  let detailData = {
    id: rawData.id,
    title: rawData.title || rawData.name,
    poster_path: rawData.poster_path
      ? poster_rootpath + rawData.poster_path
      : poster_notfound,
    release_date: rawData.release_date
      ? rawData.release_date.match(/\d{4}/g)[0]
      : "" || rawData.first_air_date
      ? rawData.first_air_date.match(/\d{4}/g)[0]
      : "",
    overview: rawData.overview,
    original_language: original_language,
  };

  if (forTag) {
    let genres = rawData.genre_ids.slice(0, 3).map((item) => {
      let targetGenre = genreList.find(
        (genre) => parseInt(genre.id) == parseInt(item)
      );
      return targetGenre.name;
    });
    detailData.genres = genres.join(", ");
    return detailData;
  } else {
    let credits = {
      director:
        rawData.credits.crew.length > 0
          ? rawData["credits"].crew.filter((p) => p.job === "Director")
          : null,
      cast: rawData.credits.cast,
    };
    detailData.runtime = rawData.runtime
      ? convertRuntime(rawData.runtime)
      : convertRuntime(rawData.episode_run_time[0]);
    detailData.country = rawData.production_countries
      .map((country) => country.name)
      .join(", ");
    detailData.tagline = rawData.tagline;
    detailData.backdrops = rawData.images.backdrops.map(item => {
      return { ...item, file_path: poster_rootpath + item.file_path };
    });
    detailData.videos = rawData.videos.results;
    detailData.credits = credits;
    detailData.recommendation = rawData.recommendations.results.map((item) =>
      extractDetailData(type, item, langConfig, genreList, true)
    );

    if (type === "mov") {
      let others = {
        genres: rawData["genres"].map((item) => item.name).join(", "),
        budget: convertToCurrency(rawData.budget),
        revenue: convertToCurrency(rawData.revenue),
        original_title: rawData.original_title,
        original_language: original_language,
        status: rawData.status,
      };
      detailData.others = others;
      detailData.belongs_to_collection =
        rawData.belongs_to_collection === null
          ? null
          : {
              id: rawData.belongs_to_collection.id,
              name: rawData.belongs_to_collection.name,
              backdrop_path:
                poster_rootpath + rawData.belongs_to_collection.backdrop_path,
              poster_path:
                poster_rootpath + rawData.belongs_to_collection.poster_path,
            };
      detailData.certification = rawData.releases.countries.find(
        (item) =>
          Object.values(item).includes("US") & (item.certification !== "")
      ) || { certification: "NoCert" };

      return detailData;
    } else {
      let others = {
        genres: rawData.genres.map((item) => item.name).join(", "),
        number_of_episodes: rawData.number_of_episodes,
        number_of_seasons: rawData.number_of_seasons,
        original_name: rawData.original_name,
        original_language: original_language,
        status: rawData.status,
        last_air_date: rawData.last_air_date,
      };
      detailData.others = others;
      detailData.created_by = rawData.created_by
        .map((item) => item.name)
        .join(rawData.created_by.length > 1 ? ", " : "");
      detailData.seasons = rawData.seasons;
      detailData.networks = rawData.networks
        .map((item) => item.name)
        .join(rawData.networks.length > 1 ? ", " : "");
      return detailData;
    }
  }
}
//extractDetailData(sampleData, sampleGenreList, sampleLangConfig, false)

//handle Season Detail & Episode General Data
export function extractSeasonData(rawData) {
  let poster_rootpath = "https://www.themoviedb.org/t/p/original";
  let poster_notfound =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png";

  let formatData = {
    ...rawData,
  };

  formatData.poster_path = poster_rootpath + formatData.poster_path;

  formatData.episodes = formatData.episodes.map((episode) => {
    let formatEpisode = {
      id: episode.id,
      title: episode.title || episode.name,
      poster_path: episode.still_path
        ? poster_rootpath + episode.still_path
        : poster_notfound,
      release_date: episode.air_date,
      overview: episode.overview,
      runtime: convertRuntime(episode.runtime),
      episode_number: episode.episode_number,
      crew: episode.crew,
      guest_stars: episode.guest_stars,
      show_id: episode.show_id,
      season_number: episode.season_number
    };
    return formatEpisode;
  });
  return formatData;
}

//handle Episode Detail
export function extractEpisodeData(rawData) {
  let poster_rootpath = "https://www.themoviedb.org/t/p/original";
  let formatData = {
    ...rawData,
  };

  const filteredAndFormattedImages = formatData.images.stills
    .filter((element) => element.file_path) 
    .map((element) => ({
      ...element,
      file_path: poster_rootpath + element.file_path,
    }));

  formatData.images.stills = filteredAndFormattedImages;

  return formatData;
}

export function extractMovData(
  detailData,
  langConfig,
  countryConfig,
  genreList
) {
  //let langConfig = detailData.langConfig;
  //let countryConfig = detailData.countryConfig;
  //let genreList = detailData.genreList;

  let langDataArr = langConfig.filter(
    (item) => item.iso_639_1 === detailData.original_language
  );

  return {
    id: detailData.id,
    title: detailData.title,
    poster_path: detailData.poster_path
      ? "https://www.themoviedb.org/t/p/original" + detailData.poster_path
      : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
    release_date: detailData.release_date
      ? detailData.release_date.match(/\d{4}/g)[0]
      : "UNK",
    overview: detailData.overview,
    backdrops: [detailData.backdrop_path],
    others: {
      genres: detailData.genre_ids
        .slice(0, 3)
        .map((item) => {
          /*let genreArr = genreList.filter((genre) => genre.id === item);
          return genreArr[0].name;*/
          const genre = genreList.find((genre) => genre.id === item);
          return genre ? genre.name : "";
        })
        .join(", "),
      original_language: langDataArr[0].english_name,
    },
  };
}

export function extractTvData(
  detailData,
  langConfig,
  countryConfig,
  genreList
) {
  //let langConfig = detailData.langConfig;
  //let countryConfig = detailData.countryConfig;
  //let genreList = detailData.genreList;

  let langDataArr = langConfig.filter(
    (item) => item.iso_639_1 === detailData.original_language
  );
  return {
    id: detailData.id,
    title: detailData.name,
    poster_path: detailData.poster_path
      ? "https://www.themoviedb.org/t/p/original" + detailData.poster_path
      : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
    release_date: detailData["first_air_date"],
    overview: detailData.overview,
    backdrops: [detailData.backdrop_path],
    others: {
      genres: detailData.genre_ids
        .slice(0, 3)
        .map((item) => {
          /*let genreArr = genreList.filter((genre) => genre.id == item);
          return genreArr[0].name;*/
          const genre = genreList.find((genre) => genre.id === item);
          return genre ? genre.name : "";
        })
        .join(", "),
      original_language: langDataArr[0].english_name,
    },
  };
}

//Filter Award, Categories, Nominees
export function filterNominees(rawData, awardId, categoryId, awardYear, winnerOnly) {
  let targetCategory = rawData.find(
    (category) =>
      category.award.id == awardId && category.category.id == categoryId
  );

  return {
    ...targetCategory,
    awardYear: awardYear,
    winnerOnly: winnerOnly,
    nominees: targetCategory.nominees.filter((nominee) => {
      return winnerOnly
        ? awardYear.includes(parseInt(nominee.awardYear)) && nominee.isWinner
        : awardYear.includes(parseInt(nominee.awardYear));
    }),
  };
}